import React from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const pageTitles = {
  '/dashboard':  'Dashboard',
  '/students':   'Students',
  '/classes':    'Classes',
  '/lessons':    'Lessons',
  '/homework':   'Homework',
  '/progress':   'Progress',
  '/media':      'Media Library',
  '/schedule':   'Schedule',
  '/settings':   'Taals & Types',
  '/export':     'Export Data',
  '/approvals':  'Approvals',
  '/payments':   'Payments',
  '/my-payments':'Payments',
};

export default function TopBar({ onMenuToggle, isMobile }) {
  const location = useLocation();
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const handleSignOut = () => { logout(); navigate('/'); };
  const base  = '/' + location.pathname.split('/')[1];
  const title = pageTitles[base] || 'RhythMicky Beats';

  return (
    <header style={s.header}>

      {/* Hamburger — only on mobile */}
      {isMobile && (
        <button style={s.menuBtn} onClick={onMenuToggle} aria-label="Open menu">
          <span style={s.bar}/><span style={s.bar}/><span style={s.bar}/>
        </button>
      )}

      {/* Amber accent bar */}
      <div style={s.accentBar}/>

      {/* Title */}
      <div style={s.titleBlock}>
        {!isMobile && <div style={s.sectionLabel}>Navigation</div>}
        <h1 style={{ ...s.title, fontSize: isMobile ? '15px' : '16px' }}>{title}</h1>
      </div>

      <div style={{ flex:1 }}/>

      {/* Right chips — hide date on mobile */}
      <div style={s.chips}>
        {!isMobile && (
          <div style={s.chip}>
            {new Date().toLocaleDateString('en-US', { month:'short', day:'numeric', year:'numeric' })}
          </div>
        )}
        <div style={s.userChip}>
          <div style={s.dot}/>
          <span style={s.chipName}>
            {user?.student?.full_name?.split(' ')[0] || (user?.username?.charAt(0).toUpperCase() + user?.username?.slice(1))}
          </span>
          {!isMobile && <span style={s.chipRole}>{isAdmin ? 'Teacher' : 'Student'}</span>}
        </div>
        <button onClick={handleSignOut}
          style={{ background: 'none', border: '1px solid #2a2927',
            color: '#6b6966', padding: '5px 12px', borderRadius: '20px',
            fontSize: '12px', cursor: 'pointer', fontFamily: "'DM Sans',sans-serif",
            flexShrink: 0, whiteSpace: 'nowrap' }}>
          {isMobile ? '→' : 'Sign Out'}
        </button>
      </div>
    </header>
  );
}

const s = {
  header: {
    height: '60px', background: '#111110',
    borderBottom: '1px solid #2a2927',
    display: 'flex', alignItems: 'center',
    padding: '0 16px 0 0', gap: 0,
    position: 'sticky', top: 0, zIndex: 50,
  },
  menuBtn: {
    background:'none', border:'none', cursor:'pointer',
    padding:'8px 14px', display:'flex', flexDirection:'column',
    gap:'4px', flexShrink: 0,
  },
  bar: { display:'block', width:'18px', height:'1.5px', background:'#c49a3c', borderRadius:'2px' },
  accentBar: { width:'3px', height:'60px', background:'#c49a3c', flexShrink:0, marginRight:'16px' },
  titleBlock: { display:'flex', flexDirection:'column', gap:'3px', minWidth:0 },
  sectionLabel: {
    fontSize:'10px', fontWeight:600, color:'#c49a3c',
    textTransform:'uppercase', letterSpacing:'1px', lineHeight:1,
  },
  title: {
    fontWeight:500, color:'#f0ede8', letterSpacing:'-0.2px',
    margin:0, lineHeight:1, fontFamily:"'DM Sans',sans-serif",
    whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis',
  },
  chips: { display:'flex', alignItems:'center', gap:'8px', flexShrink:0 },
  chip: {
    padding:'5px 12px', borderRadius:'20px',
    background:'#1c1b19', border:'1px solid #2a2927',
    fontSize:'12px', color:'#6b6966', fontFamily:"'DM Sans',sans-serif",
    whiteSpace:'nowrap',
  },
  userChip: {
    display:'flex', alignItems:'center', gap:'7px',
    padding:'5px 12px', borderRadius:'20px',
    background:'#1c1b19', border:'1px solid #2a2927',
  },
  dot: { width:'6px', height:'6px', borderRadius:'50%', background:'#c49a3c', flexShrink:0 },
  chipName: { fontSize:'12px', fontWeight:500, color:'#f0ede8', fontFamily:"'DM Sans',sans-serif", whiteSpace:'nowrap' },
  chipRole: { fontSize:'11px', color:'#6b6966', fontFamily:"'DM Sans',sans-serif" },
};
